import { Link, useParams } from 'react-router-dom';
import './PublicTicketBookingPage.css';

export default function ManualTicketPaymentPage() {
  const { bookingId } = useParams();
  return (
    <div className="ptb-root" style={{ minHeight: '100vh', padding: '6rem 1rem' }}>
      <div className="ptb-card" style={{ maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
        <h1 className="ptb-card-title">Booking Reserved</h1>
        <p>We sent PayNow and bank-transfer instructions to your booking email. Your tickets are pending until APCS verifies your payment.</p>
        <p>Send your payment proof with this booking reference:</p>
        <strong style={{ color: '#EBBC64', fontSize: '1.4rem', wordBreak: 'break-all' }}>{bookingId}</strong>
        <p>Your reserved places remain held until APCS confirms payment or cancels the booking.</p>
        <Link className="ptb-btn-primary" style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none' }} to="/">Back to Home</Link>
      </div>
    </div>
  );
}
